var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.659 12.005A3.664 3.664 0 0 1 12 15.682a3.664 3.664 0 0 1-3.659-3.677A3.664 3.664 0 0 1 12 8.328a3.664 3.664 0 0 1 3.659 3.677Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 20.5c3.608 0 6.97-2.137 9.31-5.834.92-1.449.92-3.883 0-5.332C18.97 5.637 15.608 3.5 12 3.5c-3.608 0-6.97 2.137-9.31 5.834-.92 1.449-.92 3.883 0 5.332C5.03 18.363 8.392 20.5 12 20.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye_on.be40bf8ceb49ca0f0e74c0766e6798b1.svg";
export { ForwardRef as ReactComponent };